import PropTypes from "prop-types";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// project imports
import useAuth from "hooks/useAuth";
import { DASHBOARD_PATH } from "config";
import Loader from "ui-component/Loader";

// ==============================|| GUEST GUARD ||============================== //

/**
 * Guest guard for routes having no auth required
 * @param {PropTypes.node} children children element/node
 */

const GuestGuard = ({ children }) => {
  const { isLoggedIn, isInitialized } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isInitialized && isLoggedIn) {
      navigate(DASHBOARD_PATH, { replace: true });
    }
  }, [isInitialized, isLoggedIn, navigate]);

  if (!isInitialized) {
    return <Loader />;
  }

  return !isLoggedIn ? children : null;
};

GuestGuard.propTypes = {
  children: PropTypes.node,
};

export default GuestGuard;
